import React, { useState } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { useCookies } from 'react-cookie';
import PropTypes from 'prop-types';
import { useLayout } from '../context';
import { EditWrapper, StyledLink, StyledButton, SplitTestMsg } from './styles';

import {
  getStorageValue,
  setStorageValue,
  storageValueHasBeenSet,
} from '../../../utils/session-storage';

import contentfulLink from '../../../utils/contentful-link';
import { SPLIT_VARIANT } from '../../../hooks/split-test';

const STORAGE_VALUE = 'edit-in-contentful';

const EditInContentful = ({ contentfulId }) => {
  const [isOpen, setIsOpen] = useState(() =>
    storageValueHasBeenSet(STORAGE_VALUE)
      ? getStorageValue('open', STORAGE_VALUE)
      : true
  );

  const { showQuickExitButton } = useLayout();

  const { allContentfulSplitTest } = useStaticQuery(graphql`
    query AllSplitTests {
      allContentfulSplitTest {
        nodes {
          contentful_id
          a {
            contentful_id
          }
          b {
            contentful_id
          }
        }
      }
    }
  `);

  const activeSplitTest =
    allContentfulSplitTest.nodes.length !== 0
      ? allContentfulSplitTest.nodes.find(
          (node) =>
            node.a?.contentful_id === contentfulId ||
            node.b?.contentful_id === contentfulId
        ) ?? null
      : null;

  const [cookie, setCookie] = useCookies([SPLIT_VARIANT]);
  const currentVariant = cookie[SPLIT_VARIANT];
  const otherVariant = currentVariant === 'a' ? 'b' : 'a';

  return (
    <EditWrapper
      $open={isOpen}
      aria-expanded={isOpen}
      $showQuickExitButton={showQuickExitButton}
    >
      {isOpen && (
        <>
          {activeSplitTest && currentVariant ? (
            <SplitTestMsg>
              <p>
                <strong>
                  This page is part of a{' '}
                  <a
                    href={contentfulLink(activeSplitTest.contentful_id)}
                    target="_blank"
                    rel="noreferrer"
                  >
                    split test
                  </a>
                  , you are viewing variant {currentVariant.toUpperCase()}.{' '}
                </strong>
                <StyledButton
                  bg="secondary-on-dark"
                  onClick={() => {
                    setCookie(SPLIT_VARIANT, otherVariant, {
                      path: window.location.pathname,
                    });
                    window.location.reload();
                  }}
                  size="small"
                >
                  View variant {otherVariant.toUpperCase()}{' '}
                </StyledButton>
              </p>
            </SplitTestMsg>
          ) : null}

          <StyledLink
            href={contentfulLink(
              activeSplitTest?.[currentVariant]?.contentful_id || contentfulId
            )}
            $bg="primary"
            target="_blank"
            rel="noreferrer"
            size="small"
          >
            Edit in Contentful
          </StyledLink>
        </>
      )}

      <StyledButton
        bg="secondary-on-dark"
        onClick={() => {
          setStorageValue('open', !isOpen, STORAGE_VALUE);
          setIsOpen(!isOpen);
        }}
        icon={isOpen ? `chevron-right` : `chevron-left`}
        aria-label={isOpen ? `Close` : `Open`}
        $open={isOpen}
        size="small"
      />
    </EditWrapper>
  );
};

EditInContentful.propTypes = {
  contentfulId: PropTypes.string,
};

export default EditInContentful;
